// overwrite the core environment
export const custom_environment = {
  HypCusNumber: 34007,
  CustomerName: "Hypersoft",
  YourAppServer: {
    BaseURI: "https://demo.myhypersoftapp.de/",
    ClientID: "YourApp"
  },
  ImageServerURI: "https://demo.myhypersoftapp.de/ImageHandler.ashx",
  IntentScheme: "yourapp34007",
  storeURL: {
    GooglePlayStore: "https://play.google.com/store/apps/details?id=de.myhypersoftapp.hypersoft",
    AppleStore: "https://itunes.apple.com/app/id1497125424"
  },
  checkout_in_test_mode: true,
  DISABLE_LOCATION_SELECTION_IN_BONUSSYSTEM: true
};
